import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, ListGroup, Spinner, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

// for all page of dashboard
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import { ProfileAPI } from '../services/api'; // Assuming ProfileAPI is exported from the api.js
import '../styles/Style.css';

const Profile = () => {
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const isMounted = useRef(false);

  // Check if the user is logged in
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    document.body.classList.add('loged-body');

    return () => {
      document.body.classList.remove('loged-body');
    };
  }, []);

  // Fetch user profile once
  useEffect(() => {

    if (!isMounted.current) {
      const fetchProfile = async () => {
        console.log("Fetching profile...");
        try {
          const data = await ProfileAPI();
          setUser(data.data);
          setLoading(false);
        } catch (error) {
          setError('Failed to fetch user profile.');
          setLoading(false);
        }
      };

      fetchProfile();
      isMounted.current = true;
    }
  }, []);

  return (
    <>
      <Sidebar />
      <WebNav />
      <div className="d-body login-body">
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col md={8}>
              <Card>
                <Card.Header className="text-center">
                  <h2>Profile Information</h2>
                </Card.Header>
                <Card.Body>
                  {loading && (
                    <div className="text-center">
                      <Spinner animation="border" variant="primary" />
                      <h5>Loading...</h5>
                    </div>
                  )}

                  {error && (
                    <Alert variant="danger" className="text-center">
                      {error}
                    </Alert>
                  )}

                  {user && !loading && !error && (
                    <Row>
                      <Col md={4} className="text-center">
                        <FontAwesomeIcon icon={faUser} size="4x" className="mb-3" />
                        <h4>{`${user.name}`}</h4>
                      </Col>
                      <Col md={8}>
                        <ListGroup variant="flush">
                          <ListGroup.Item>
                            <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                            <strong>Email:</strong> {user.email}
                          </ListGroup.Item>
                          <ListGroup.Item>
                            <FontAwesomeIcon icon={faPhone} className="me-2" />
                            <strong>Phone:</strong> {user.phone}
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Profile;
